import { defaultConfig } from '@/cms/api/ApiConfig';
import store from '@/store/store';
import AxiosService from './axiosService';
import { getBrandForConsent, isDevelop } from './environmentService';
import TestConfig from '@/views/digitalAccept/TestData/TestData';
import { createDigitalAcceptSubmitRequest } from './acceptSubmitService';
import { ConsentResponse, UserConsentsResponse } from '@/types/types';
import { createConsentBody } from './consentService';
import { Log } from '@/appinsights/logging/log';

export const getProposal = async (receipt = false) => {
	const baseUrl = defaultConfig.baseUrl + store.state.proxyUrl;
	const proposeUrl = `/quote-accept/quote/${store.state.ProposalContext.quote_id}
		?customer_no=${store.state.ProposalContext.customerNo}&signature=${store.state.ProposalContext.signatureId}&timestamp=${store.state.ProposalContext.timestamp}`;
	const axiosService = new AxiosService();
	let proposal: any;

	try {
		const url = baseUrl + proposeUrl;
		proposal = await axiosService.getRetry(url);
	} catch (e) {
		Log.exception('cannot load proposal', e, { quoteId: store.state.ProposalContext.quote_id });
	}

	if (proposal?.status !== 200 && isDevelop) {
		console.warn('fallback DEV load HardCoded proposal');
		// proposal = receipt ? TestConfig.getReceiptHardCoded() : TestConfig.getMock();
		proposal = TestConfig.getMock();
		return proposal;
	}
	return proposal;
};

export const getInsuranceCompanies = async () => {
	const baseUrl = defaultConfig.baseUrl + store.state.proxyUrl;
	const proposeUrl = `/quote-accept/insurance-companies`;
	const axiosService = new AxiosService();
	let proposal: any;

	try {
		const url = baseUrl + proposeUrl;
		proposal = await axiosService.get(url);
	} catch (e) {
		Log.exception('cannot load insurance companies', e, { quoteId: store.state.ProposalContext.quote_id });
	}

	return proposal;
};
export const submitProposal = async () => {
	const baseUrl = defaultConfig.baseUrl + store.state.proxyUrl;
	const proposeUrl = `/quote-accept/quote/${store.state.ProposalContext.quote_id}
		?customer_no=${store.state.ProposalContext.customerNo}&signature=${store.state.ProposalContext.signatureId}&timestamp=${store.state.ProposalContext.timestamp}`;
	const axiosService = new AxiosService();
	const url = baseUrl + proposeUrl;
	const proposalRes = await axiosService.patch(url, createDigitalAcceptSubmitRequest());
	return proposalRes;
};

// KLK ERROR Submit
export const getConsentText = async (): Promise<ConsentResponse> => {
	const baseUrl = defaultConfig.baseUrl + store.state.proxyUrl;
	// const consentUrl = `/quote-accept/quote/${store.state.ProposalContext.quote_id}/consents
	// 	?customer_no=${store.state.ProposalContext.customerNo}&signature=${store.state.ProposalContext.signatureId}&timestamp=${store.state.ProposalContext.timestamp}`;

	// /api/v3/openserviceproxy

	const brand = getBrandForConsent();
	const consentUrl = `/consents/consentlist?BusinessBrand=${brand}&apiversion=2.0`;

	const axiosService = new AxiosService();
	let consentResponse: any;

	try {
		const url = baseUrl + consentUrl;
		consentResponse = await axiosService.get(url);
	} catch (e) {
		Log.exception('cannot load consent', e, { quoteId: store.state.ProposalContext.quote_id });
	}

	if (consentResponse?.status !== 200 && isDevelop) {
		console.warn('fallback DEV load HardCoded consent');
		consentResponse = TestConfig.getPolicyConsentHardCoded();
	}
	// KLK perhaps popup with load error and ask user to try again later or call us?
	return consentResponse;
};

export const getUserConsent = async (): Promise<UserConsentsResponse> => {
	const baseUrl = defaultConfig.baseUrl + store.state.proxyUrl;
	//9692615710
	const brand = getBrandForConsent();
	const consentUrl = `/consents/customer/${store.state.ProposalContext.customerNo}?businessBrand=${brand}`;

	const axiosService = new AxiosService();
	let userConsentResponse: UserConsentsResponse;

	try {
		const url = baseUrl + consentUrl;
		userConsentResponse = await axiosService.get(url);
	} catch (e) {
		Log.exception('cannot load consent', e, { quoteId: store.state.ProposalContext.quote_id });
		console.error(e);
	}

	if (userConsentResponse?.status !== 200 && isDevelop) {
		console.warn('fallback DEV load HardCoded consent');
		userConsentResponse = TestConfig.getPolicyConsentHardCoded().data as any;
	}
	// KLK perhaps popup with load error and ask user to try again later or call us?
	return userConsentResponse;
};

// KLK ERROR Submit - handle errors when SalesForce service is up and running
export const submitConsent = async () => {
	try {
		const baseUrl = defaultConfig.baseUrl + store.state.proxyUrl;
		const consentUrl = `/quote-accept/quote/${store.state.ProposalContext.quote_id}/consents
		?customer_no=${store.state.ProposalContext.customerNo}&signature=${store.state.ProposalContext.signatureId}&timestamp=${store.state.ProposalContext.timestamp}`;
		const axiosService = new AxiosService();
		const url = baseUrl + consentUrl;
		// KLK only submit consent that are newly selected, not any false or original.
		const consentBody = createConsentBody();
		if (!consentBody) {
			console.warn('No consents to submit');
			return;
		}
		await axiosService.put(url, consentBody);
	} catch (e) {
		Log.exception('cannot submit consent', e, { quoteId: store.state.ProposalContext.quote_id });
	}
};
